import React from "react";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { loginWithGoogle, user, logout } = useAuth();

  return (
    <div>
      {user ? (
        <>
          <h2>Welcome, {user.displayName}</h2>
          <button onClick={logout}>Logout</button>
        </>
      ) : (
        <button onClick={loginWithGoogle}>Sign in with Google</button>
      )}
    </div>
  );
};

export default Login;
